import { Link } from "react-router-dom";

export default function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section
      className="relative border-b border-border overflow-hidden"
      data-testid="page-header"
    >
      <div className="absolute inset-0 grid-bg opacity-50" />
      <div
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage: image ? `url(${image})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%) contrast(1.2)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/70 to-background" />

      <div className="container-x relative py-16 md:py-24">
        <nav className="text-xs font-display uppercase tracking-[0.22em] text-muted-foreground mb-5">
          <Link to="/" className="hover:text-primary">Ana Sayfa</Link>
          <span className="mx-2 text-primary">/</span>
          <span className="text-foreground">{eyebrow || title}</span>
        </nav>
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className="heading-xl">{title}</h1>
        {subtitle && (
          <p className="mt-5 max-w-2xl text-base md:text-lg text-muted-foreground leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
